export const getSectionFieldName = (
    sectionName?: string,
    fieldName?: string,
    index?: number,
) =>
    index !== undefined
        ? `${sectionName ?? ""}.${fieldName ?? ""}.${index}`
        : `${sectionName ?? ""}.${fieldName ?? ""}`
